import {React,useEffect,useState,useRef} from "react";
import {useHistory} from 'react-router-dom'
import { useSelector,useDispatch } from "react-redux";
import ReactLoading from 'react-loading';
import {toast} from 'react-toastify'

import './Payment.scss'
import { getData } from "../Services/APIService";
import config from "../Services/config.json";
import { updateCustomer } from './../../ReduxActions/customerAction';
import {changeNumbers} from '../Common/regex'
import JButton from '../../components/Button/JButton';

const Payment= () => {

    const dispatch = useDispatch();

    const history = useHistory();
    const customer = useSelector(state => state.customer);
    const [getPayWay,setPayWay] = useState(1);
    const [getSelectedBank,setSelectedBank] = useState(0);
    const [getBackColorServiceType,setBackColorServiceType] = useState("");
    const [getBorderColorServiceType,setBorderColorServiceType] = useState("");
    const [getLoading,setLoading] = useState(true);
    const [getLoadingDiscount,setLoadingDiscount] = useState(false);
    const [getItemsTitle,setItemsTitle] = useState([]);
    const [getItemsPrice,setItemsPrice] = useState([]);
    const [getBanks,setBanks] = useState([]);
    const [getAmount,setAmount]=useState(0);
    const [getImage,setImage]=useState("");
    const [getFake,setFake]=useState(0);
    const txtDiscountCode = useRef();
    const divPayWayDiscount=useRef();
    
    useEffect( () => {
        window.scrollTo(0, 0)
        
        if(customer.serviceCode === 0 || customer.FactorCode === 0){
            let search = window.location.search;
            let params = new URLSearchParams(search);
            var serviceCode=parseInt(params.get('serviceCode'));
            var factorCode=parseInt(params.get('factorCode'));
            var serviceType=parseInt(params.get('serviceType'));
            var customerCode=parseInt(params.get('customerCode'));
            dispatch(updateCustomer({serviceCode:serviceCode,FactorCode:factorCode,CustomerCode:customerCode,serviceType:serviceType}));

            if(serviceCode===0 || factorCode===0 || !params.get('serviceCode') || !params.get('factorCode') ){
                history.push("/");
            }
            else
            {
                setFake(1);//برای تغییر استیت و صدا زدن متد لود
            }
        }
        else
        {
            setFake(1);
        }

        if(customer.DiscountCode!="")
            handleDiscountCode();

        // if(customer.serviceCode === 0 || customer.FactorCode === 0){
        //     history.push("/");
        // }
        // else
        // {
        //     setFake(1);
            
        //     if(customer.DiscountCode!="")
        //         handleDiscountCode();
        // }

        console.log("StoreLog: ",divPayWayDiscount.current.getBoundingClientRect().left);
   },[]);

   useEffect( () => {
       if(getFake != 0)
            handleLoadInfo();
    },[getFake]);

   const handleLoadInfo = async () =>{
    
    if(customer.serviceType === 1){
        setBackColorServiceType(" backADSL");
        setBorderColorServiceType(" borderADSL");
    }
    else if(customer.serviceType === 2){
        setBackColorServiceType(" backLTE");
        setBorderColorServiceType(" borderLTE");
    }
    else if(customer.serviceType === 3){
        setBackColorServiceType(" backGaming");
        setBorderColorServiceType(" borderGaming");
    }

    const info={
        token: config.APIKey,
        serviceCode:customer.serviceCode,
        equipmentCode:customer.equipmentCode,
        factorCode:customer.FactorCode,
        customerCode:customer.CustomerCode
     };
     try{
        const {data}=await getData('store/GetPackageInfo',info);

        if (data.Result !== 4 && data.Message!== null) {
            toast.error(data.Message,{
                position:'bottom-left',
                closeButton:true,
                closeOnClick:true
            });
        }
        else if (data.Result !== 4) {
            //toast.error("خطایی رخ داده است",{position:'bottom-left',closeButton:true,closeOnClick:true});
            console.log("StoreError: ","خطایی رخ داده است");
        }
        else{
            setItemsTitle(data.title);
            setItemsPrice(data.price);
            setAmount(data.amount);
            setImage(data.image);
            setBanks(data.banks);

            if(data.banks.length>0){
                setSelectedBank(data.banks[0].code);
                dispatch(updateCustomer({Bank:data.banks[0].code,BankName:data.banks[0].name,BankLogo:data.banks[0].logo}));
            }

            if(data.discountCard != ""){
                dispatch(updateCustomer({DiscountCode:data.discountCard}));
                txtDiscountCode.current.value=data.discountCard;
            }
        }
    }
    catch(ex){
        // toast.error("مشکلی پیش آمده.", {
        //     position: "bottom-left",
        //     closeOnClick: true
        // });
        console.log("StoreError: ",ex.Message);
    }

    setLoading(false);
   }

   const handleDiscountCode = async (e)=>{
        e.preventDefault();

        setLoadingDiscount(true);

        console.log("StoreLog: ","Register discount card");

        const info={
            token: config.APIKey,
            CustomerCode:customer.CustomerCode,
            FactorCode:customer.FactorCode,
            DiscountCode:txtDiscountCode.current.value
        };

        try{
            const {data}=await getData('store/CheckDiscountCode',info);
            
            if (data.Result !== 4 && data.Message!== null) {
                toast.error(data.Message,{position:'bottom-left',closeButton:true,closeOnClick:true});
            }
            else if (data.Result !== 4) {
                toast.error("خطایی رخ داده است دوباره تلاش کنید",{position:'bottom-left',closeButton:true,closeOnClick:true});
            }
            else{
                dispatch(updateCustomer({DiscountCode:txtDiscountCode.current.value}));
                setFake(2);
                toast.success("کد تخفیف اعمال شد",{position:'bottom-left',closeButton:true,closeOnClick:true});
            }
        }
        catch(ex){
            console.log("StoreError: ",ex.Message);
        }

        setLoadingDiscount(false);
   }

    const handlePayWay = (way) =>{
        setPayWay(way);
        dispatch(updateCustomer({PayWay:way}));
   }

   const handleSelectedBank = (bank,name,logo) =>{
        setSelectedBank(bank);
        dispatch(updateCustomer({Bank:bank,BankName:name,BankLogo:logo}));
    }

    return ( 
        <div className="payment">
            {getLoading ? <ReactLoading type="bubbles" color={"#ff8035"} height={150} width={120} className="reactLoading" /> : null}
            <div className="payWayDiscountBanks">
                {/* <div className="payWayDiscountBanksSideLeft"></div> */}
                <div className="divContentDiscountBanks">
                    <div className="payWayDiscount" ref={divPayWayDiscount}>
                        <div className="payDiscount">
                            <label className="payWayTitle">: کد تخفیف</label>
                            <div className="PayDiscountBox">
                                <label> کد تخفیف خود را وارد کنید</label>
                                <div className="PayDiscountBox2">
                                    {/* <div className="btnDiscount" onClick={handleDiscountCode}>
                                        <span>
                                            {
                                                !getLoadingDiscount ? "اعمال کد تخفیف" :
                                                <ReactLoading type="bubbles" color={"#ff8035"} />
                                            }
                                        </span>
                                    </div> */}
                                    <div className="btnDiscount">
                                        <JButton handleClick={handleDiscountCode} title={!getLoadingDiscount ? "اعمال کد تخفیف" :  <ReactLoading type="bubbles" color={"#ff8035"} />} disabled={getLoadingDiscount ? true : false} type={"Black"} noSize={true} />
                                    </div>
                                    <input type="text" className="txtDiscount" ref={txtDiscountCode} placeholder="لطفا کد تخفیف خود را وارد نمایید"></input>
                                    <span className="fa fa-percent"></span>
                                </div>
                                <div className="btnDiscount2">
                                    {/* <span>اعمال کد تخفیف</span> */}
                                    <JButton handleClick={handleDiscountCode} title={!getLoadingDiscount ? "اعمال کد تخفیف" :  <ReactLoading type="bubbles" color={"#ff8035"} />} type={"Black"} noSize={true} />
                                </div>
                            </div>
                        </div>
                        <div className="payWaySeperator"></div>
                        <div className="payWayP">
                            <label className="payWayTitle">: شیوه پرداخت</label>
                            <div className="payWaySP">
                                <div className="payWay">
                                    <div className={`payWayBox ${ getPayWay === 2 ? " payWayBoxChecked "+getBackColorServiceType : ""}`}>
                                        <div className={`payWayCheck ${ getPayWay === 2 ? " payWayChecked" : ""}`}  onClick={() => handlePayWay(2)}>
                                            <span className="fa fa-check"></span>
                                        </div>
                                        <span className="fa fa-money"></span>
                                        <label>پرداخت در محل</label>
                                    </div>
                                </div>
                                <div className="payWay">
                                    <div className={`payWayBox ${ getPayWay === 1 ? " payWayBoxChecked "+getBackColorServiceType  : ""}`}>
                                        <div className={`payWayCheck${ getPayWay === 1 ? " payWayChecked" : ""}`} onClick={() =>  handlePayWay(1)}>
                                            <span className="fa fa-check"></span>
                                        </div>
                                        <span className="fa fa-credit-card"></span>
                                        <label>پرداخت اینترنتی</label>
                                    </div>
                                </div>
                            </div>
                            {getBanks.length>0 && getPayWay ===1 ? 
                            <div className='banks' >
                                {
                                    getBanks.sort((a, b) => a.code > b.code ? 1 : -1).map((item,index) => (
                                    <div className="payWay">
                                        <div className={`payWayBox dynamicsize ${ (getSelectedBank === item.code ? " payWayBoxChecked payWayBoxbank"+getBackColorServiceType : " payWayBoxbank")+getBorderColorServiceType}`}>
                                            <div className={`payWayCheck payWayCheckBank ${ getSelectedBank === item.code ? " payWayChecked" : ""}`}  onClick={() => handleSelectedBank(item.code,item.name,item.logo)}>
                                                <span className="fa fa-check"></span>
                                            </div>
                                            <div className="boxbankdes">
                                                <div className="boxbank">
                                                    <img className="imgBank" width="60" height="60" src={item.logo}></img>
                                                    <label>{item.description=='' ? item.name : ''}</label>
                                                </div>
                                                <div className="boxbankdescription">
                                                    <label>{item.description}</label>
                                                    <label>{item.description2}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            :null}
                        </div>
                    </div>
                    
                </div>
                {/* <div className="payWayDiscountBanksSideRight"></div> */}
            </div>
            <div className="summary">
                <div className="summarySeperator">
                    <div></div>
                    <span>خلاصه سفارش</span>
                </div>
                <div className="summaryContent">
                    <div className="summarySubContent">
                        <div className="summaryInfo">
                            <div>
                                {
                                getItemsTitle.map((item,index) => (
                                <div className="summaryInfoItems">
                                    <label>{changeNumbers(parseInt(getItemsPrice[index]).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))} ریال</label>
                                    <span>{item}</span>
                                </div>
                                ))}
                            </div>
                            <div className="summaryInfoPrice">
                                <div className="summaryInfoPrice1"></div>
                                <div className="summaryInfoPrice2"></div>

                                <div className="summaryInfoItems">
                                    <label>{changeNumbers(getAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))} ریال</label>
                                    <span>مبلغ قابل پرداخت</span>
                                </div>
                            </div>
                        </div>
                        <img className="summaryImage" src={getImage}></img>
                    </div>
                </div>
            </div>
        </div>
        
     );
}

export default Payment;
